import { EntityScheduleType } from '@common/models/Enums';
import { BaseEntitySchedulePreference } from './BaseEntitySchedulePreference';
import { DateTime } from 'luxon';
import { DateTimeUtils } from '@common/utils/datetimeUtils';

/**
 * Represents a Schedule Preference that have may have been modified via processing logic in the HospitalScheduleModelFactory
 * ComputedSchedulePreferences are now how background events on the calendar are generated.  The computed preferences are the
 * result of the final preferences for an entity (vet or template) after having applied overrides, default preferences, etc.
 */
export class ComputedSchedulePreference extends BaseEntitySchedulePreference {
  hospitalId: number;
  uniqueId: string;
  entityPreferenceId: number;
  entityType: EntityScheduleType;
  entityId: number;
  isOverride: boolean;
  overrideNotes?: string | null;
  overrideDate?: DateTime | null;
  inheritedFromTemplate: boolean;
  inheritedTemplateId: number | undefined;

  constructor(init?: Partial<ComputedSchedulePreference>) {
    super(init);
    this.hospitalId = _.defaultTo(init?.hospitalId, 0);
    this.uniqueId = _.defaultTo(init?.uniqueId, '');
    this.entityPreferenceId = _.defaultTo(init?.entityPreferenceId, 0);
    this.entityType = _.defaultTo(
      init?.entityType,
      EntityScheduleType.Veterinarian,
    );
    this.entityId = _.defaultTo(init?.entityId, 0);
    this.isOverride = _.defaultTo(init?.isOverride, false);
    this.overrideNotes = _.defaultTo(init?.overrideNotes, null);
    this.overrideDate = DateTimeUtils.getAsDateTimeUTC(init?.overrideDate);
    this.inheritedFromTemplate = _.defaultTo(
      init?.inheritedFromTemplate,
      false,
    );
    this.inheritedTemplateId = _.defaultTo(
      init?.inheritedTemplateId,
      undefined,
    );
  }
}
